export function getMerchantId(selectedStore) {
  const {
    pos_id_code: posId,
    pos_tenancy: { company_id: companyId, retailer_id: retailerId },
  } = selectedStore;

  if (!companyId && !retailerId) {
    return null;
  }

  return [posId, companyId, retailerId].filter((entry) => entry).join('-');
}

export function getStoreAndMerchantIds(selectedStore) {
  const {
    pos_id_code: posId,
    pos_tenancy: { company_id: companyId, retailer_id: retailerId },
    uuid: storeUUID,
  } = selectedStore;

  if (!companyId && !retailerId) {
    return null;
  }

  const merchantId = [posId, companyId, retailerId]
    .filter((entry) => entry)
    .join('-');

  return {
    merchantId,
    storeUUID,
  };
}

export function isCanadianStore(selectedStore) {
  const pointOfSales = selectedStore?.point_of_sales?.toLowerCase?.();
  if (pointOfSales) {
    return pointOfSales === 'greenline';
  }

  return selectedStore?.pos_id_code?.toLowerCase?.() === 'blc';
}
